import React, { useState, useRef, Fragment, useMemo } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Backdrop, Box, Button, Card, Typography } from "@mui/material";
import classes from "./loginPage.module.scss";
import {
  IMG_BG,
  IMG_EXCELENCIA,
  IMG_INTEGRIDAD,
  IMG_OFFICE_365,
  IMG_PEAJE,
  IMG_SEGURIDAD,
  IMG_SOSTENIBILIDAD,
  LOGO_HORIZONTAL_2,
} from "../../constants/images";
import InputText from "../UI/Inputs/InputText";
import { IsMobile } from "../../utils/utils";
import { animated, useSpring } from "@react-spring/web";
import moment from "moment";
import { useTranslation } from "react-i18next";

import UserIcon from "@mui/icons-material/PermIdentityOutlined";
import PasswordIcon from "@mui/icons-material/HttpsOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined";
import FormComments from "../Comments/FormComments";
import { getGlobalCsrToken } from "../../api";
import { urlFormLogin, urlFormOas365 } from "../../api/urls";
import { useSelector } from "react-redux";
import i18next from "i18next";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const LoginPage = ({ accessRestricted }) => {
  const isMobile = IsMobile();
  const [user, setUser] = useState(null);
  const [password, setPassword] = useState(null);
  return (
    <Box className="d-flex flex-column flex-grow-1 h-100" sx={{ backgroundColor: "#fff" }}>
      <Header />
      <Box className="flex-grow-1 position-relative d-flex flex-column align-items-center w-100">
        <Box
          className="d-flex flex-column align-items-center w-100"
          sx={{
            position: "absolute",
            top: isMobile ? "-200px" : "-60%",
            paddingBottom: "100px",
          }}
        >
          <LoginTitle isMobile={isMobile} />
          <LoginForm user={user} setUser={setUser} password={password} setPassword={setPassword} isMobile={isMobile} />
          <AppsInfo />
          {/* <ContactButton /> */}

          {isMobile && <Footer isMobile={isMobile} />}
        </Box>

        {!isMobile && <Footer isMobile={isMobile} />}
      </Box>
    </Box>
  );
};

export default LoginPage;

const Header = () => {
  return (
    <Box className="bg-cover-bottom position-relative" sx={{ height: "40%", background: `url(${IMG_BG})` }}>
      <div className="custom-shape-divider-bottom-1720612983">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
            opacity=".25"
            className="shape-fill"
          ></path>
          <path
            d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
            opacity=".5"
            className="shape-fill"
          ></path>
          <path
            d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
            className="shape-fill"
          ></path>
        </svg>
      </div>
    </Box>
  );
};
const LoginTitle = ({ isMobile }) => {
  const { t } = useTranslation();
  const springs = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    delay: 500,
    config: { mass: 1, tension: 10, friction: 1 },
  });
  return (
    <animated.div
      style={{
        ...springs,
      }}
    >
      <Typography variant={isMobile ? "h4" : "h3"} className={["text-center"].join(" ")} sx={{ color: "#fff" }}>
        {t("login.loginTitle")}
      </Typography>
      <Typography className="text-center" sx={{ color: "#fff" }}>
        {t("login.loginSubtitle")}
      </Typography>
    </animated.div>
  );
};
const LoginForm = ({ isMobile, user, password, setUser, setPassword }) => {
  const accessRestricted = useSelector((state) => state.app.accessRestricted);
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation();
  const springs = useSpring({
    from: { y: -500 },
    to: { y: 0 },
    delay: 100,
  });
  const handleChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  };
  return (
    <animated.div
      style={{
        minHeight: "300px",
        width: "500px",
        maxWidth: "80%",
        backgroundColor: "#fff",
        zIndex: 1,
        borderRadius: "4px",
        ...springs,
      }}
      className={"mt-5 d-flex flex-column"}
    >
      <Backdrop sx={{ zIndex: 1 }} open={expanded} />
      <Card className="d-flex flex-column p-3 flex-grow-1" elevation={3} sx={{ zIndex: 2 }}>
        <div className="d-flex  align-items-center justify-content-between">
          <img src={LOGO_HORIZONTAL_2} height="34px" alt="" />
          {!isMobile && <Typography sx={{ fontSize: "1.2rem", color: "#424242" }}>{t("login.initSession")}</Typography>}
        </div>
        <form action={urlFormOas365} className="mt-3 w-100">
          <Button
            size="large"
            variant="contained"
            className="text-bold w-100 btn-blue"
            type="submit"
            data-testid="oficeLogin"
          >
            <img src={IMG_OFFICE_365} height={30} alt="" className="mr-2" /> {t("login.officeLogin")}
          </Button>
          <input type="hidden" name="redirect" value="landingpage" />
          <input type="hidden" name="_csrf" value={getGlobalCsrToken()} />
        </form>

        <Accordion className="mt-4" expanded={expanded} onChange={handleChange}>
          <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
            <Typography>{t("login.userPasswordLogin")}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {expanded && (
              <form id="command" action={urlFormLogin} method="post" className="d-flex flex-column align-items-end">
                <InputText
                  label={t("login.user")}
                  placeholder={t("login.userPlaceholder")}
                  value={user}
                  onChange={setUser}
                  // focused
                  Icon={UserIcon}
                  className="mt-4 w-100"
                  id="username"
                  name="username"
                  autoFocus
                />
                <InputText
                  label={t("login.password")}
                  placeholder={t("login.passwordPlaceholder")}
                  value={password}
                  inputType="password"
                  onChange={setPassword}
                  // focused
                  Icon={PasswordIcon}
                  className={"mt-2 w-100"}
                  id="password"
                  name="password"
                />

                <div
                  className={
                    isMobile
                      ? "text-center d-flex flex-column w-100"
                      : "d-flex align-items-center justify-content-end w-100"
                  }
                >
                  <Button
                    size="large"
                    className={isMobile ? "mt-2 w-100" : ""}
                    disabled={!user || !password}
                    type="submit"
                  >
                    {t("login.localLogin")}
                  </Button>
                </div>

                <input type="hidden" name="redirect" value="landingpage" />
                <input type="hidden" id="client_id" name="client_id" value="SSOTTS" />
                <input type="hidden" name="_csrf" value={getGlobalCsrToken()} />
              </form>
            )}
            <Typography className="text-right mt-2" variant="body2">
              {t("login.forgotPassword")} <a href="mailto:mas@aleatica.com">mas@aleatica.com</a>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <div className="flex-grow-1 align-items-end d-flex">
          {accessRestricted && (
            <Typography color="error" className="mt-3">
              {accessRestricted}
            </Typography>
          )}
        </div>
      </Card>
    </animated.div>
  );
};

const AppsInfo = () => {
  const { t } = useTranslation();
  return (
    <div className="container flex-grow-1 d-flex flex-column justify-content-center align-items-center mt-5">
      <Box className="row w-100 flex-grow-1 mt-5">
        <Item
          title={t("login.appType1Title")}
          subtitle={t("login.appType1Subtitle")}
          color="#72B52F"
          image={IMG_SEGURIDAD}
          index={1}
        />
        <Item
          title={t("login.appType2Title")}
          subtitle={t("login.appType2Subtitle")}
          color="#F29802"
          image={IMG_INTEGRIDAD}
          index={2}
        />
        <Item
          title={t("login.appType3Title")}
          subtitle={t("login.appType3Subtitle")}
          color="#20B2E3"
          image={IMG_EXCELENCIA}
          index={3}
        />
        <Item
          title={t("login.appType4Title")}
          subtitle={t("login.appType4Subtitle")}
          color="#786B63"
          image={IMG_PEAJE}
          index={4}
        />
        <Item
          title={t("login.appType5Title")}
          subtitle={t("login.appType5Subtitle")}
          color="#ffd600"
          image={IMG_SOSTENIBILIDAD}
          index={5}
        />
      </Box>
    </div>
  );
};

export const ContactButton = () => {
  const { t } = useTranslation();
  return (
    <Button variant="contained" color="secondary" className={classes.contactButton}>
      <EmailOutlinedIcon className="mr-2" />
      {t("login.contact")}
    </Button>
  );
};
const Item = ({ title, subtitle, color, image, black, index }) => {
  const [enter, setEnter] = useState(false);
  const cardRef = useRef(null);
  const config = {
    mass: 1,
    tension: 170,
    friction: 26,
    clamp: false,
    precision: 0.01,
    velocity: 0,
  };
  const springs = useSpring({
    from: { x: -500, opacity: 0 },
    to: { x: 0, opacity: 1 },
    delay: index * 100,
    config: { mass: 2, tension: 100, friction: 18 },
  });
  const [{ xys }, api] = useSpring(() => ({ xys: [0, 0, 1], config }), [config]);

  const handleMouseLeave = () => {
    setEnter(false);
    api.start({
      xys: [0, 0, 1],
    });
  };

  const handleMouseMove = (e) => {
    const rect = cardRef.current.getBoundingClientRect();
    api.start({
      xys: calc(e.clientX, e.clientY, rect),
    });
  };

  return (
    <Box className="col-md d-flex flex-column align-items-center justify-content-center" ref={cardRef}>
      <animated.div
        style={{ transform: xys.to(trans), ...springs }}
        onMouseEnter={() => setEnter(true)}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseMove}
        className="w-100 d-flex justify-content-center"
      >
        <Box
          className="d-flex flex-column align-items-center position-relative overflow-hidden"
          sx={{
            backgroundColor: color,
            borderRadius: "25px 136px 25px 136px",
            width: "100%",
            maxWidth: "200px",
            height: "80%",
            minHeight: "260px",
            padding: "30px 30px",
            cursor: "pointer",
          }}
        >
          {/* imagen icono */}
          <img src={image} alt="" className={[classes.itemImage, enter ? classes.itemImageEnter : ""].join(" ")} />

          <Typography
            className="text-center mt-2"
            sx={{ color: black ? "#000" : "#fff", fontWeight: "bold", fontSize: "1.2rem", lineHeight: "1.2rem" }}
          >
            {title}
          </Typography>

          {enter && (
            <Typography
              className="text-center mt-3"
              sx={{ color: black ? "#000" : "#fff", fontSize: "0.9rem", lineHeight: "0.9rem" }}
            >
              {subtitle}
            </Typography>
          )}

          <div className={classes.itemBlock} />
        </Box>
      </animated.div>
    </Box>
  );
};

export const Footer = ({ isMobile, relative, fixed }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user.user);
  const [showCommentsForm, setShowCommentsForm] = useState(false);
  const springs = useSpring({
    from: { height: 0 },
    to: { height: 40 },
    delay: 500,
    // config: { mass: 1, tension: 10, friction: 1 },
  });

  const showCommentsFormHandler = () => {
    setShowCommentsForm(true);
  };
  const closeCommentsFormHandler = () => {
    setShowCommentsForm(false);
  };

  const linkLang = useMemo(() => {
    const lang = i18next.languages && i18next.languages.length && i18next.languages[0] === "es" ? "es" : "en";
    return lang;
  }, [i18next.languages]);

  return (
    <Fragment>
      <animated.div
        style={{
          ...springs,
          backgroundColor: "rgb(243 243 243)",
          // backgroundColor: "#78909c",
          position: relative ? "relative" : isMobile && !fixed ? "absolute" : "fixed",
          bottom: 0,
        }}
        className="w-100"
      >
        <div className="container d-flex align-items-center justify-content-between h-100">
          {!isMobile && <Typography variant="caption">{t("footer", { year: moment().year() })}</Typography>}

          <Typography className="d-flex align-items-center justify-content-end" variant="caption">
            <Button size="small" className="mr-3" onClick={showCommentsFormHandler}>
              <CommentOutlinedIcon className="mr-2" fontSize="small" />
              {t("comments.title")}
            </Button>
            <a
              href={`https://labs.aleatica.com/cookies_advice_${linkLang}.html`}
              className="mr-3"
              target="_blank"
              rel="noreferrer"
            >
              <Button size="small" className="mr-3">
                {t("cookies")}
              </Button>
            </a>
            <a href={`https://labs.aleatica.com/private_advice_${linkLang}.html`} target="_blank" rel="noreferrer">
              <Button size="small" className="mr-3">
                {t("privacyAdvice")}
              </Button>
            </a>
          </Typography>
        </div>
      </animated.div>
      {showCommentsForm && <FormComments onClose={closeCommentsFormHandler} />}
    </Fragment>
  );
};

const calc = (x, y, rect) => [-(y - rect.top - rect.height / 2) / 5, (x - rect.left - rect.width / 2) / 5, 1.2];

const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`;
